import {
  ServiceEnvironment,
  ServicesDropdownItem,
} from '@3ddv/software-division-components/backoffice/services-dropdown';
import { AuthServiceEntry } from '../models/auth.model';
import { environment } from 'src/environments/environment';

export function sdcEnvironmentFor(
  tier: 'local' | 'dev' | 'pre' | 'prod'
): ServiceEnvironment {
  switch (tier) {
    case 'prod':
      return 'prod';
    case 'pre':
      return 'uat';
    case 'dev':
    case 'local':
      return 'dev';
  }
}

function toIconUrl(
  icon: string | undefined,
  iconBaseUrl: string
): string | undefined {
  const path = (icon ?? '').replace(/^(\s|%20)+/i, '').trim();
  if (!path) {
    return undefined;
  }
  if (/^https?:\/\//.test(path)) {
    return path;
  }

  return `${iconBaseUrl.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
}

export function toProductSwitcherItems(
  services: readonly AuthServiceEntry[],
  iconBaseUrl: string = environment.serviceIconBaseUrl
): ServicesDropdownItem[] {
  return services.map(service => ({
    name: service.publicname ?? service.name,
    key: service.key,
    domain: service.domain,
    iconUrl: toIconUrl(service.icon, iconBaseUrl),
  }));
}
